var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 229,
    viewBox: "0 0 212 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.786 227.4V162.102H12.3945V157.706H31.4052V125.928H55.3472V143.844H74.8857V227.4H16.786Z",
    fill: "#7EACEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.236 139.554H174.329V144.544H176.502V151.275H165.109V108.305H143.005V227.4H199.269V144.544H201.236V139.554Z",
    fill: "#7EACEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.077 89.5151C166.077 89.5151 165.494 84.1286 173.065 84.7107C173.065 84.7107 174.652 79.5632 180.237 78.8872C186.539 78.1246 188.643 82.7041 189.371 83.723C189.371 83.723 199.447 81.2164 200.612 89.5151H166.077Z",
    fill: "#EFF6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.509521 117.04C0.509521 117.04 0.964183 108.626 10.0407 111.258C10.0407 111.258 13.536 105.563 20.0715 107.209C22.22 107.75 24.13 109.069 25.2017 111.008C26.0024 112.456 26.5072 114.46 25.8218 117.04H0.509521Z",
    fill: "#EFF6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 99.8633H63.9843V129.255H150.29V99.8633Z",
    fill: "#D9E8FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 172.366H63.9843V222.755H150.29V172.366Z",
    fill: "#D9E8FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 136.114H63.9843V165.506H150.29V136.114Z",
    fill: "#D9E8FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 63.6113H63.9844V93.0025H150.29V63.6113Z",
    fill: "#D9E8FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 129.255H60.0646V133.344H153.455V129.255Z",
    fill: "#EFF6FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.797 133.344H61.7231V136.114H151.797V133.344Z",
    fill: "#21248A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 165.506H60.0646V169.596H153.455V165.506Z",
    fill: "#EFF6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.797 169.595H61.7231V172.365H151.797V169.595Z",
    fill: "#21248A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 56.7514H60.0646V60.8412H153.455V56.7514Z",
    fill: "#EFF6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.797 60.8413H61.7231V63.6115H151.797V60.8413Z",
    fill: "#21248A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 93.0033H60.0646V97.0932H153.455V93.0033Z",
    fill: "#EFF6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.797 97.0926H61.7231V99.8628H151.797V97.0926Z",
    fill: "#21248A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5905 67.9024H78.7867V88.288H92.5905V67.9024Z",
    fill: "#62A0FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 72.1309H81.1298V77.4615H90.2471V72.1309Z",
    fill: "#1E1E83"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 79.4002H81.1298V84.7309H90.2471V79.4002Z",
    fill: "#1E1E83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.072 65.9175H75.8441V69.8873H95.072V65.9175Z",
    fill: "#5389FA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0721 86.8821H75.8442V90.8519H95.0721V86.8821Z",
    fill: "#5389FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.052 67.9023H121.248V88.2879H135.052V67.9023Z",
    fill: "#62A0FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 72.1306H123.592V77.4612H132.709V72.1306Z",
    fill: "#1E1E83"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 79.3999H123.592V84.7305H132.709V79.3999Z",
    fill: "#1E1E83"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 65.9174H118.305V69.8872H137.533V65.9174Z",
    fill: "#5389FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 86.8818H118.305V90.8516H137.533V86.8818Z",
    fill: "#5389FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5906 104.076H78.7868V124.462H92.5906V104.076Z",
    fill: "#62A0FB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 108.305H81.1299V113.636H90.2471V108.305Z",
    fill: "#1E1E83"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 115.574H81.1299V120.905H90.2471V115.574Z",
    fill: "#1E1E83"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0721 102.092H75.8442V106.061H95.0721V102.092Z",
    fill: "#5389FA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0722 123.056H75.8443V127.026H95.0722V123.056Z",
    fill: "#5389FA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M135.052 104.076H121.248V124.462H135.052V104.076Z",
    fill: "#62A0FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 108.305H123.592V113.636H132.709V108.305Z",
    fill: "#1E1E83"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 115.574H123.592V120.905H132.709V115.574Z",
    fill: "#1E1E83"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 102.092H118.305V106.062H137.533V102.092Z",
    fill: "#5389FA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 123.056H118.306V127.026H137.533V123.056Z",
    fill: "#5389FA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5906 140.328H78.7868V160.714H92.5906V140.328Z",
    fill: "#62A0FB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 144.556H81.1299V149.887H90.2471V144.556Z",
    fill: "#1E1E83"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 151.825H81.1299V157.156H90.2471V151.825Z",
    fill: "#1E1E83"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0721 138.343H75.8442V142.313H95.0721V138.343Z",
    fill: "#5389FA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0722 159.307H75.8443V163.277H95.0722V159.307Z",
    fill: "#5389FA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.052 140.328H121.248V160.713H135.052V140.328Z",
    fill: "#62A0FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 144.556H123.592V149.887H132.709V144.556Z",
    fill: "#1E1E83"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M132.709 151.825H123.592V157.156H132.709V151.825Z",
    fill: "#1E1E83"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 138.343H118.305V142.312H137.533V138.343Z",
    fill: "#5389FA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 159.307H118.306V163.277H137.533V159.307Z",
    fill: "#5389FA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.909 50.1828H123.865V56.7516H140.909V50.1828Z",
    fill: "#CCE0F7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.001 47.5033H122.773V50.3122H142.001V47.5033Z",
    fill: "#20238B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8483 50.1826H70.6824V56.7514H80.8483V50.1826Z",
    fill: "#CCE0F7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8379 47.5031H69.6654V50.3119H81.8379V47.5031Z",
    fill: "#20238B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M110.426 63.6114H102.372V93.0026H110.426V63.6114Z",
    fill: "#CCE0F7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0384 63.6114L63.9844 63.6113V93.0025L72.0384 93.0026V63.6114Z",
    fill: "#CCE0F7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 63.6113L142.236 63.6114V93.0026L150.29 93.0025V63.6113Z",
    fill: "#CCE0F7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0384 99.8633H63.9843V129.255H72.0384V99.8633Z",
    fill: "#CCE0F7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 99.8633H142.236V129.255H150.29V99.8633Z",
    fill: "#CCE0F7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110.426 99.8633H102.372V129.255H110.426V99.8633Z",
    fill: "#CCE0F7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0384 136.114H63.9843V165.506H72.0384V136.114Z",
    fill: "#CCE0F7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 136.114H142.236V165.506H150.29V136.114Z",
    fill: "#CCE0F7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M110.426 136.114H102.372V165.506H110.426V136.114Z",
    fill: "#CCE0F7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 222.755H60.0646V227.5H153.455V222.755Z",
    fill: "#CCE0F7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0384 183.824H63.9844V222.738H72.0384V183.824Z",
    fill: "#CCE0F7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29 183.824H142.236V222.738H150.29V183.824Z",
    fill: "#CCE0F7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5905 185.329H78.7867V205.715H92.5905V185.329Z",
    fill: "#62A0FB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 196.826H81.1298V202.157H90.2471V196.826Z",
    fill: "#1E1E83"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2471 189.557H81.1298V194.888H90.2471V189.557Z",
    fill: "#1E1E83"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0721 204.309H75.8442V208.278H95.0721V204.309Z",
    fill: "#5389FA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M135.382 185.329H121.578V205.715H135.382V185.329Z",
    fill: "#62A0FB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M133.038 196.826H123.921V202.157H133.038V196.826Z",
    fill: "#1E1E83"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M133.038 189.557H123.921V194.888H133.038V189.557Z",
    fill: "#1E1E83"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M137.863 204.309H118.635V208.278H137.863V204.309Z",
    fill: "#5389FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M114.907 192.223H99.6311V222.755H114.907V192.223Z",
    fill: "#1E1E83"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M116.517 222.755H98.0286V227.5H116.517V222.755Z",
    fill: "#A6C4DD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0558 172.366C62.0558 172.366 58.6534 172.263 58.8455 179.069H154.61C154.61 179.069 155.453 172.366 150.914 172.366H62.0558Z",
    fill: "#D9E8FD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M155.704 179.069H58.0205V182.216H155.704V179.069Z",
    fill: "#B4CDE5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7381 183.824C57.7381 186.122 59.6685 187.984 62.0504 187.984C64.4317 187.984 66.3626 186.122 66.3626 183.824C66.3626 183.254 66.2431 182.71 66.028 182.215H58.0727C57.8571 182.71 57.7381 183.254 57.7381 183.824Z",
    fill: "#5389FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6982 183.824C67.6982 186.122 69.6285 187.984 72.0104 187.984C74.3918 187.984 76.3227 186.122 76.3227 183.824C76.3227 183.254 76.2031 182.71 75.9881 182.215H68.0328C67.8172 182.71 67.6982 183.254 67.6982 183.824Z",
    fill: "#5389FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1435 186.719C65.1435 186.719 67.0613 185.156 68.915 186.719L69.1572 182.253L64.2264 182.215L65.1435 186.719Z",
    fill: "#5389FA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1026 186.719C75.1026 186.719 77.0204 185.156 78.8741 186.719L79.1163 182.253L74.1855 182.215L75.1026 186.719Z",
    fill: "#5389FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6583 183.824C77.6583 186.122 79.5887 187.984 81.9706 187.984C84.3519 187.984 86.2828 186.122 86.2828 183.824C86.2828 183.254 86.1633 182.71 85.9482 182.215H77.9929C77.7773 182.71 77.6583 183.254 77.6583 183.824Z",
    fill: "#5389FA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6188 183.824C87.6188 186.122 89.5491 187.984 91.931 187.984C94.3124 187.984 96.2433 186.122 96.2433 183.824C96.2433 183.254 96.1237 182.71 95.9087 182.216H87.9534C87.7383 182.71 87.6188 183.254 87.6188 183.824Z",
    fill: "#5389FA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0641 186.719C85.0641 186.719 86.9819 185.156 88.8356 186.719L89.0778 182.253L84.147 182.216L85.0641 186.719Z",
    fill: "#5389FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.024 186.719C95.024 186.719 96.9418 185.156 98.7949 186.719L99.0371 182.253L94.1063 182.216L95.024 186.719Z",
    fill: "#5389FA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6055 183.824C97.6055 186.122 99.5358 187.984 101.918 187.984C104.299 187.984 106.23 186.122 106.23 183.824C106.23 183.254 106.11 182.71 105.895 182.215H97.9401C97.725 182.71 97.6055 183.254 97.6055 183.824Z",
    fill: "#5389FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107.566 183.824C107.566 186.122 109.497 187.984 111.878 187.984C114.259 187.984 116.19 186.122 116.19 183.824C116.19 183.254 116.071 182.71 115.856 182.216H107.9C107.685 182.71 107.566 183.254 107.566 183.824Z",
    fill: "#5389FA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M105.011 186.719C105.011 186.719 106.929 185.156 108.782 186.719L109.025 182.253L104.094 182.216L105.011 186.719Z",
    fill: "#5389FA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M114.971 186.719C114.971 186.719 116.889 185.156 118.742 186.719L118.984 182.253L114.053 182.216L114.971 186.719Z",
    fill: "#5389FA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.526 183.824C117.526 186.122 119.457 187.984 121.839 187.984C124.22 187.984 126.151 186.122 126.151 183.824C126.151 183.254 126.031 182.71 125.816 182.215H117.861C117.646 182.71 117.526 183.254 117.526 183.824Z",
    fill: "#5389FA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M127.487 183.824C127.487 186.122 129.417 187.984 131.799 187.984C134.181 187.984 136.112 186.122 136.112 183.824C136.112 183.254 135.992 182.71 135.777 182.216H127.822C127.606 182.71 127.487 183.254 127.487 183.824Z",
    fill: "#5389FA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M124.932 186.719C124.932 186.719 126.85 185.156 128.704 186.719L128.946 182.253L124.015 182.216L124.932 186.719Z",
    fill: "#5389FA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M134.892 186.719C134.892 186.719 136.809 185.156 138.663 186.719L138.905 182.253L133.974 182.216L134.892 186.719Z",
    fill: "#5389FA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M137.461 183.824C137.461 186.122 139.392 187.984 141.774 187.984C144.155 187.984 146.086 186.122 146.086 183.824C146.086 183.254 145.966 182.71 145.751 182.215H137.796C137.58 182.71 137.461 183.254 137.461 183.824Z",
    fill: "#5389FA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M147.422 183.824C147.422 186.122 149.352 187.984 151.734 187.984C154.115 187.984 156.046 186.122 156.046 183.824C156.046 183.254 155.927 182.71 155.712 182.216H147.756C147.541 182.71 147.422 183.254 147.422 183.824Z",
    fill: "#5389FA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M144.867 186.719C144.867 186.719 146.785 185.156 148.638 186.719L148.88 182.253L143.95 182.216L144.867 186.719Z",
    fill: "#5389FA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0395 92.3385H52.8537C52.2002 90.4708 50.06 89.0916 47.4928 89.0916C44.9256 89.0916 42.7849 90.4708 42.1318 92.3385H39.086V161.273H42.2879C43.0907 162.936 45.1104 164.122 47.4928 164.122C49.8752 164.122 51.8948 162.936 52.6976 161.273H56.0395V92.3385Z",
    fill: "#62A0FB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2678 97.1275V103.638H48.4262V101.099H45.9148V103.638H44.0732V97.1275H45.9148V99.5737H48.4262V97.1275H50.2678Z",
    fill: "#EFF6FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3565 114.769C46.6682 114.769 46.0481 114.623 45.4963 114.331C44.9506 114.04 44.5196 113.637 44.2034 113.122C43.8934 112.608 43.7383 112.028 43.7383 111.383C43.7383 110.738 43.8934 110.158 44.2034 109.644C44.5196 109.129 44.9506 108.726 45.4963 108.434C46.0481 108.143 46.6682 107.997 47.3565 107.997C48.0448 107.997 48.6618 108.143 49.2075 108.434C49.7593 108.726 50.1903 109.129 50.5004 109.644C50.8166 110.158 50.9747 110.738 50.9747 111.383C50.9747 112.028 50.8166 112.608 50.5004 113.122C50.1903 113.637 49.7593 114.04 49.2075 114.331C48.6618 114.623 48.0448 114.769 47.3565 114.769ZM47.3565 113.243C47.6852 113.243 47.9828 113.166 48.2494 113.011C48.5161 112.856 48.7269 112.639 48.8819 112.36C49.037 112.074 49.1145 111.749 49.1145 111.383C49.1145 111.017 49.037 110.695 48.8819 110.416C48.7269 110.13 48.5161 109.91 48.2494 109.755C47.9828 109.6 47.6852 109.523 47.3565 109.523C47.0279 109.523 46.7302 109.6 46.4636 109.755C46.197 109.91 45.9861 110.13 45.8311 110.416C45.6761 110.695 45.5986 111.017 45.5986 111.383C45.5986 111.749 45.6761 112.074 45.8311 112.36C45.9861 112.639 46.197 112.856 46.4636 113.011C46.7302 113.166 47.0279 113.243 47.3565 113.243Z",
    fill: "#EFF6FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4591 120.588H43.4593V119.127H49.2912V120.588H47.3007V125.638H45.4591V120.588Z",
    fill: "#EFF6FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3005 135.215V136.638H44.0732V130.127H49.1796V131.551H45.8962V132.648H48.7889V134.025H45.8962V135.215H49.3005Z",
    fill: "#EFF6FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0732 141.127H45.9148V146.178H49.0215V147.638H44.0732V141.127Z",
    fill: "#EFF6FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M185.542 206.618C186.748 199.213 181.723 192.232 174.318 191.026C166.913 189.819 159.932 194.844 158.726 202.249C157.519 209.654 162.544 216.635 169.949 217.841C177.354 219.048 184.335 214.023 185.542 206.618Z",
    fill: "#D9E8FD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6125 206.62C56.8189 199.215 51.7939 192.234 44.3889 191.028C36.9839 189.822 30.003 194.847 28.7966 202.251C27.5902 209.656 32.6151 216.637 40.0201 217.844C47.4251 219.05 54.406 214.025 55.6125 206.62Z",
    fill: "#D9E8FD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3148 1.47524L70.2098 32.0001H61.5757L66.3288 8.14709H60.6599L62.0117 1.47524H76.3148Z",
    fill: "#7EACEE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3216 8.14709L88.057 12.595H89.3652C93.0863 12.595 95.9207 13.3218 97.8685 14.7753C99.8163 16.2289 100.79 18.3366 100.79 21.0983C100.79 23.424 100.151 25.459 98.8715 27.2033C97.6214 28.9476 95.8771 30.2849 93.6387 31.2151C91.4002 32.1454 88.8564 32.6106 86.0075 32.6106C83.769 32.6106 81.6613 32.3344 79.6845 31.782C77.7076 31.2006 75.9924 30.3575 74.5388 29.2528L78.5507 23.1043C79.6263 23.9183 80.8618 24.5433 82.2573 24.9794C83.6818 25.4154 85.1208 25.6335 86.5743 25.6335C88.3186 25.6335 89.6704 25.3282 90.6298 24.7177C91.5891 24.0781 92.0688 23.206 92.0688 22.1013C92.0688 21.2001 91.6764 20.5169 90.8914 20.0518C90.1356 19.5576 88.9 19.3105 87.1848 19.3105H78.4199L83.5219 1.47524H102.927L101.575 8.14709H89.3216Z",
    fill: "#7EACEE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M115.373 32.6106C111.856 32.6106 109.065 31.5785 107.001 29.5145C104.966 27.4213 103.948 24.5287 103.948 20.8367C103.948 17.1156 104.631 13.7433 105.998 10.7199C107.393 7.66742 109.326 5.26904 111.798 3.52477C114.269 1.75142 117.059 0.864746 120.17 0.864746C123.688 0.864746 126.464 1.91131 128.499 4.00444C130.563 6.0685 131.595 8.94655 131.595 12.6386C131.595 16.3597 130.897 19.7465 129.502 22.799C128.136 25.8224 126.217 28.2208 123.746 29.9941C121.275 31.7384 118.484 32.6106 115.373 32.6106ZM116.202 25.5462C117.597 25.5462 118.804 24.8631 119.821 23.4967C120.839 22.1304 121.609 20.4588 122.132 18.4819C122.656 16.5051 122.917 14.63 122.917 12.8566C122.917 11.1705 122.597 9.93498 121.958 9.15005C121.347 8.33606 120.475 7.92906 119.342 7.92906C117.946 7.92906 116.74 8.61224 115.722 9.97859C114.705 11.3449 113.934 13.0165 113.411 14.9934C112.888 16.9702 112.626 18.8453 112.626 20.6187C112.626 23.9037 113.818 25.5462 116.202 25.5462Z",
    fill: "#7EACEE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M156.169 19.921H148.799L147.36 27.1161H140.644L142.084 19.921H134.714L135.979 13.5543H143.348L144.787 6.35922H151.503L150.064 13.5543H157.433L156.169 19.921Z",
    fill: "#7EACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.9ce5700408f1efa75acd84b010595d89.svg";
export { ForwardRef as ReactComponent };